import { EpimsBaseEntityDto } from './epim-base.dto';
export class RequestTypeDto extends EpimsBaseEntityDto {
RequestTypeName: string;
SubscriptionUserId: string;
Version: number;
}
